import { useMutation } from '@tanstack/react-query';
import { jobsService } from '../jobsService';
import { IBulkConfirmPayload } from '../types/bulkConfirmTypes';

export function useBulkConfirmJobs() {
  return useMutation<string[], Error, IBulkConfirmPayload>({
    mutationFn: async (payload: IBulkConfirmPayload) => {
      return await jobsService.bulkConfirmJobs(payload);
    },
  });
}
